export default "__VITE_ASSET__DPKuHV84__"